import React from 'react';
import { Star } from 'lucide-react';
import { StatusIndicator } from '../../components/StatusIndicator/StatusIndicator';
import { cn } from '../../utils/cn';

/**
 * ArticleStatusBadge / ArticleFeaturedBadge / ArticleTypeLabel — patterns piste 8.
 *
 * Statuts d'articles rendus en `StatusIndicator` (dot + label uppercase font-semibold),
 * pas en pilule colorée. Plus typographique, plus signature.
 */

const STATUS_MAP = {
  PUBLISHED: { tone: 'ink',   label: 'Publié' },
  SCHEDULED: { tone: 'info',  label: 'Programmé' },
  DRAFT:     { tone: 'faded', label: 'Brouillon' },
  ARCHIVED:  { tone: 'muted', label: 'Archivé' },
};

const TYPE_LABELS = {
  VEILLE_TECHNOLOGIQUE: 'Veille techno',
  VEILLE_JURIDIQUE: 'Veille juridique',
  STAGE: 'Stage',
  PPE: 'PPE',
  PP: 'PP',
  OTHER: 'Autre',
};

export function ArticleStatusBadge({ status, size = 'md', uppercase = false, className }) {
  const cfg = STATUS_MAP[status] || STATUS_MAP.DRAFT;
  return (
    <StatusIndicator tone={cfg.tone} size={size} uppercase={uppercase} className={className}>
      {cfg.label}
    </StatusIndicator>
  );
}

export function ArticleFeaturedBadge({ size = 'md', className }) {
  const sizeCls = { sm: 'text-[10.5px] h-5 px-1.5', md: 'text-[11px] h-6 px-2', lg: 'text-[12px] h-7 px-2.5' }[size] || 'text-[11px] h-6 px-2';
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-ink text-cream font-bold uppercase tracking-wider',
        sizeCls,
        className,
      )}
    >
      <Star className="w-3 h-3 fill-current" strokeWidth={0} />
      À la une
    </span>
  );
}

export function ArticleTypeLabel({ type, className }) {
  return <span className={className}>{TYPE_LABELS[type] || type || '—'}</span>;
}

export { TYPE_LABELS as ARTICLE_TYPE_LABELS };
export default ArticleStatusBadge;
